import {
  SessionRole,
  Inserter,
  Wrapper,
  PartAdminMenu,
} from "nystem-components";

const PartAdmin = () => (
  <Inserter match="/admin*">
    <SessionRole userrole="config super">
      <Wrapper className="m-auto mt-10 max-w-6xl overflow-hidden rounded-xl border border-stone-300 bg-white shadow-lg md:flex">
        <Wrapper className="admin-sidebar flex bg-emerald-950 p-1 text-emerald-50 md:block md:min-w-56 md:pb-20">
          <PartAdminMenu />
        </Wrapper>
        <Wrapper className="admin-content max-w-3xl grow bg-stone-50 px-5 pb-32 pt-4">
          <Inserter match="/admin" source="/user/list" />
          <Inserter match="/admin/content*" source="/content*" />
          <Inserter match="/admin/user*" source="/user*" />
          <Inserter match="/admin/page*" source="/page*" />
          <Inserter match="/admin/mission*" source="/mission*" />
          <Inserter match="/admin/customer*" source="/customer*" />
          <Inserter match="/admin/tag*" source="/tag*" />
          <Inserter match="/admin/menu*" source="/menu*" />
        </Wrapper>
      </Wrapper>
    </SessionRole>
  </Inserter>
);

export default PartAdmin;
